export const tenMinutes = 10 * 60 * 1000

export const pageHeaderHeights = {
  mobile: '95px',
  desktop: '72px',
}
